<ng-template #foundingMemberModal let-modal>
    <div id="founding-member-modal" class="modal-body c-p-0">
        <div class="top-banner d-flex justify-content-between align-items-center">
            <span class="banner-text">
                Get your <strong>founding member</strong> plan
            </span>
            <span aria-label="Close" (click)="close()" class="close-btn">
                <svg width="12" height="12" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.49194 0.299149C9.01554 -0.127971 9.78754 -0.0978251 10.2757 0.390295C10.7639 0.878442 10.7941 1.65044 10.3669 2.17415L10.2757 2.27571L7.21714 5.33293L10.2745 8.39027L10.3669 8.49187C10.7937 9.0156 10.7625 9.78774 10.2745 10.2757C9.7862 10.7637 9.0142 10.7941 8.4906 10.3668L8.389 10.2757L5.333 7.2184L2.27703 10.2757C1.75642 10.7964 0.912349 10.7963 0.391616 10.2757C-0.129117 9.75507 -0.129064 8.91107 0.391616 8.39027L3.44754 5.33293L0.39031 2.27571L0.299163 2.17415C-0.12797 1.65044 -0.0978365 0.878442 0.39031 0.390295C0.87847 -0.0978251 1.65048 -0.127971 2.17416 0.299149L2.27572 0.390295L5.333 3.4476L8.39034 0.390295L8.49194 0.299149Z" fill="#121212"/>
                </svg>
            </span>
        </div>

        
        <div class="promotional-section c-m-24 d-flex align-items-center c-gap-16">
            <div class="limited-badge">
                <ng-lottie [options]="limitedOptions" (animationCreated)="onLimitedAnimationCreated($event)" style="width: 24px; height: 24px"></ng-lottie>
            </div>
            <p class="promotional-text d-flex flex-column c-gap-4">
                <span class="first-line d-flex align-items-center c-gap-4">
                    <span>🎉</span><span>650+ authors use crewfiction to sell more books.</span>
                </span>
                <span class="second-line">
                    Be one of the first 150 to lock in email marketing + author swaps.
                </span>
            </p>
        </div>
        <div class="main-content d-flex c-gap-24 c-pt-0">
            <div class="founding-member-details">
                <div class="limited-badge-overlay">LIMITED TO 150 AUTHORS</div>
                <div class="subscribers-section">
                    <h2 class="plan-title">Founding member</h2>
                    <p class="plan-description">Email marketing + author swaps to sell more books</p>
                    
                    <div class="subscriber-selector" ngbDropdown>
                        <button class="subscriber-dropdown d-flex justify-content-center align-items-center c-gap-8 w-100" ngbDropdownToggle>
                            <span>{{ selectedSubscriberLabel }}</span>
                            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.71967 0.46967C1.01256 0.176777 1.48744 0.176777 1.78033 0.46967L5.25 3.93934L8.71967 0.46967C9.01256 0.176777 9.48744 0.176777 9.78033 0.46967C10.0732 0.762563 10.0732 1.23744 9.78033 1.53033L5.78033 5.53033C5.48744 5.82322 5.01256 5.82322 4.71967 5.53033L0.71967 1.53033C0.426777 1.23744 0.426777 0.762563 0.71967 0.46967Z" fill="#4A4A4A"/>
                            </svg>
                        </button>
                        <ul ngbDropdownMenu class="dropdown-menu w-100">
                            <li *ngFor="let option of subscriberOptions" (click)="selectSubscribers(option.value)">
                                <span class="dropdown-item pointy" ngbDropdownItem>{{ option.label }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="features-section">
                    <ul class="features-list">
                        <li *ngFor="let feature of features" class="feature-item d-flex align-items-center">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9.29 16.29L5.7 12.7C5.31 12.31 5.31 11.68 5.7 11.29C6.09 10.9 6.72 10.9 7.11 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.7 16.29C10.32 16.68 9.68 16.68 9.29 16.29Z" fill="#86C1A1"/>
                            </svg>
                            <div class="feature-content">
                                <span>
                                    {{ feature }}
                                </span>
                                <span *ngIf="feature == 'Multi-retailer links'" class="feature-subtext-2">Amazon, Kobo, Barnes & Noble, and more</span>
                                <span *ngIf="feature == 'Everything in Free'" class="feature-subtext-2">Author site, book import, reader magnets, ARCs</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="pricing-options">
                <ng-container *ngIf="!shouldShowDemo">
                    <app-pricing-card
                        *ngFor="let plan of pricingPlans"
                        [plan]="plan"
                        [selectedPricing]="selectedPricing"
                        (selected)="selectPricing($event)"
                    ></app-pricing-card>

                    <button 
                        class="c-btn dark"
                        [disabled]="loading"
                        (click)="upgrade()"
                    >
                        <span *ngIf="!loading">Upgrade to Founding Member</span>
                        <span *ngIf="loading">Loading...</span>
                    </button>
                    
                    <span class="price-lock-text text-center">Price locks in for as long as you stay subscribed</span>
                </ng-container>
                
                <ng-container *ngIf="shouldShowDemo">
                    <h2 class="special-pricing-header">Special pricing</h2>
                    <a 
                        class="c-btn dark"
                        href="https://calendly.com/sam-crewfiction/30min"
                        target="_blank"
                    >
                        Get a demo
                </a>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

